import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, branch, lifecycle, renderComponent, withHandlers } from 'recompose';
import { t } from '../../../../modules/infra/i18n';
import FormWrapper from './containers/FormWrapper';
import SimpleHeader from '../../headers/simpleHeader';
import OverlaySpinner from '../../../common/OverlaySpinner';
import * as actions from './actions';
import * as shapes from './shapes';
import * as selectors from './selectors';
import { filterUnchangedAssignments, getBaseUrl, getInitialValuesFromTax } from './helpers';
import { withActionByRole } from '../../../common/helpers/actions';
import { trimFunction } from '../../../common/trimData';
import { isBrandViewActive, getBarberUser, getRoleIdType } from '../../../auth/selectors';
import withNotifications from '../../../common/withNotifications';

const Edit = (props) => (
  <div>
    <SimpleHeader heading={t('settings:taxes.edit_tax_title')} />
    <FormWrapper
      initialValues={getInitialValuesFromTax(props.tax)}
      onSubmit={trimFunction(props.onSubmit)}
      onDelete={trimFunction(props.onDelete)}
      baseUrl={props.baseUrl}
      tax={props.tax}
      edit
    />
  </div>
);

Edit.propTypes = {
  onSubmit: shapes.handler.isRequired,
  onDelete: shapes.handler.isRequired,
  tax: shapes.tax,
  baseUrl: shapes.url.isRequired,
};

Edit.defaultProps = { tax: null };

const mapStateToProps = (state, ownProps) => ({
  tax: selectors.byId(state, ownProps.params.id),
  baseUrl: getBaseUrl(getBarberUser(state), isBrandViewActive(state)),
  roleIdType: getRoleIdType(state),
});

export default compose(
  withRouter,
  withNotifications,
  connect(mapStateToProps),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (this.props.roleIdType.id !== prevProps.roleIdType.id) {
        this.props.router.replace(this.props.baseUrl);
      }
    },
  }),
  withActionByRole('updateTax', actions.updateShopTax, actions.updateBarberTax, actions.updateBrandTax),
  withActionByRole('fetchTax', actions.fetchShopTax, actions.fetchBarberTax, actions.fetchBrandTax),
  withActionByRole('deleteTax', actions.deleteShopTax, actions.deleteBarberTax, actions.deleteBrandTax),
  withHandlers({
    onSubmit: (props) => async (values) => {
      await props.updateTax(props.params.id, filterUnchangedAssignments(values, props.tax));
      props.router.replace(props.baseUrl);
      props.addNotification({
        level: 'success',
        message: t('settings:taxes.tax_saved_successfully'),
        title: t('common:success_title'),
      });
    },
    onDelete: (props) => () => props.deleteTax(props.params.id),
    fetchData: (props) => () => props.fetchTax(props.params.id),
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.tax) this.props.fetchData();
    },
  }),
  branch((props) => !props.tax, renderComponent(OverlaySpinner))
)(Edit);
